import { render } from "./PointGiveView.vue?vue&type=template&id=a8d304aa"
import script from "./PointGiveView.vue?vue&type=script&lang=js"
export * from "./PointGiveView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__